import { ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class ShareType extends ModelBase {
    static typeName = "ShareType";

    public shareTypeId: number = 0;

    @Rules.StringLength(500)
    @Rules.Required()
    public shareTypeName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.shareTypeName) {
            return "New share type";
        } else {
            return this.shareTypeName;
        }
    }
}